// Mock data for MicroRealEstate clone
export const mockProperties = [
  {
    id: 1,
    name: "Sunset Apartments",
    address: "123 Main Street, Downtown",
    units: 12,
    occupiedUnits: 10,
    totalValue: 850000,
    monthlyIncome: 8500,
    images: [
      "https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=400&h=300&fit=crop"
    ],
    status: "active",
    createdAt: "2024-01-15"
  },
  {
    id: 2,
    name: "Green Valley Complex",
    address: "456 Oak Avenue, Suburbs",
    units: 8,
    occupiedUnits: 7,
    totalValue: 620000,
    monthlyIncome: 6200,
    images: [
      "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=400&h=300&fit=crop"
    ],
    status: "active",
    createdAt: "2024-02-20"
  },
  {
    id: 3,
    name: "City Center Tower",
    address: "789 Business District, City",
    units: 20,
    occupiedUnits: 18,
    totalValue: 1200000,
    monthlyIncome: 15000,
    images: [
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=400&h=300&fit=crop"
    ],
    status: "active",
    createdAt: "2024-03-10"
  }
];

export const mockTenants = [
  {
    id: 1,
    name: "John Smith",
    email: "john.smith@email.com",
    phone: "+1 (555) 123-4567",
    propertyId: 1,
    unitNumber: "A101",
    rentAmount: 850,
    rentDue: "2024-08-01",
    leaseStart: "2024-01-01",
    leaseEnd: "2024-12-31",
    status: "active",
    paymentStatus: "paid",
    documents: ["lease.pdf", "insurance.pdf"],
    profileImage: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face"
  },
  {
    id: 2,
    name: "Sarah Johnson",
    email: "sarah.johnson@email.com",
    phone: "+1 (555) 987-6543",
    propertyId: 1,
    unitNumber: "B205",
    rentAmount: 920,
    rentDue: "2024-08-01",
    leaseStart: "2024-02-01",
    leaseEnd: "2025-01-31",
    status: "active",
    paymentStatus: "overdue",
    documents: ["lease.pdf"],
    profileImage: "https://images.unsplash.com/photo-1494790108755-2616b612b5fc?w=150&h=150&fit=crop&crop=face"
  },
  {
    id: 3,
    name: "Michael Chen",
    email: "michael.chen@email.com",
    phone: "+1 (555) 246-8135",
    propertyId: 2,
    unitNumber: "C312",
    rentAmount: 775,
    rentDue: "2024-08-01",
    leaseStart: "2024-03-01",
    leaseEnd: "2025-02-28",
    status: "active",
    paymentStatus: "pending",
    documents: ["lease.pdf", "insurance.pdf", "background_check.pdf"],
    profileImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face"
  },
  {
    id: 4,
    name: "Emily Davis",
    email: "emily.davis@email.com",
    phone: "+1 (555) 369-2580",
    propertyId: 3,
    unitNumber: "D408",
    rentAmount: 1200,
    rentDue: "2024-08-01",
    leaseStart: "2024-04-01",
    leaseEnd: "2025-03-31",
    status: "active",
    paymentStatus: "paid",
    documents: ["lease.pdf"],
    profileImage: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face"
  }
];

export const mockPayments = [
  {
    id: 1,
    tenantId: 1,
    tenantName: "John Smith",
    propertyName: "Sunset Apartments",
    unitNumber: "A101",
    amount: 850,
    dueDate: "2024-08-01",
    paidDate: "2024-07-28",
    status: "paid",
    method: "bank_transfer",
    transactionId: "TXN123456789"
  },
  {
    id: 2,
    tenantId: 2,
    tenantName: "Sarah Johnson",
    propertyName: "Sunset Apartments",
    unitNumber: "B205",
    amount: 920,
    dueDate: "2024-08-01",
    paidDate: null,
    status: "overdue",
    method: null,
    transactionId: null
  },
  {
    id: 3,
    tenantId: 3,
    tenantName: "Michael Chen",
    propertyName: "Green Valley Complex",
    unitNumber: "C312",
    amount: 775,
    dueDate: "2024-08-01",
    paidDate: null,
    status: "pending",
    method: null,
    transactionId: null
  },
  {
    id: 4,
    tenantId: 4,
    tenantName: "Emily Davis",
    propertyName: "City Center Tower",
    unitNumber: "D408",
    amount: 1200,
    dueDate: "2024-08-01",
    paidDate: "2024-07-30",
    status: "paid",
    method: "credit_card",
    transactionId: "TXN987654321"
  }
];

export const mockLeases = [
  {
    id: 1,
    name: "Standard Residential Lease",
    description: "Standard one-year residential lease agreement",
    template: "residential_standard",
    active: true,
    clauses: [
      "Monthly rent payment due on 1st of each month",
      "Security deposit equal to one month's rent",
      "No pets without written permission",
      "Tenant responsible for utilities"
    ]
  },
  {
    id: 2,
    name: "Short-term Rental Agreement",
    description: "Flexible short-term rental for 6 months or less",
    template: "short_term",
    active: true,
    clauses: [
      "Rent due monthly in advance",
      "30-day notice required for termination",
      "Furnished unit included",
      "All utilities included in rent"
    ]
  }
];

export const mockReports = [
  {
    id: 1,
    title: "Monthly Rent Collection Report",
    type: "rent_collection",
    period: "July 2024",
    totalExpected: 12745,
    totalCollected: 11825,
    collectionRate: 92.8,
    overdue: 920,
    generated: "2024-08-01"
  },
  {
    id: 2,
    title: "Property Occupancy Report",
    type: "occupancy",
    period: "Q2 2024",
    totalUnits: 40,
    occupiedUnits: 35,
    occupancyRate: 87.5,
    vacantUnits: 5,
    generated: "2024-07-01"
  },
  {
    id: 3,
    title: "Maintenance Requests Report",
    type: "maintenance",
    period: "July 2024",
    totalRequests: 15,
    completedRequests: 12,
    pendingRequests: 3,
    avgCompletionTime: "2.3 days",
    generated: "2024-08-01"
  }
];

export const mockMaintenanceRequests = [
  {
    id: 1,
    tenantId: 1,
    tenantName: "John Smith",
    propertyName: "Sunset Apartments",
    unitNumber: "A101",
    title: "Kitchen Faucet Leak",
    description: "The kitchen faucet has been leaking for the past few days. Water is dripping constantly.",
    priority: "medium",
    status: "in_progress",
    category: "plumbing",
    submittedDate: "2024-07-28",
    scheduledDate: "2024-08-02",
    images: ["https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=300&h=200&fit=crop"]
  },
  {
    id: 2,
    tenantId: 3,
    tenantName: "Michael Chen",
    propertyName: "Green Valley Complex",
    unitNumber: "C312",
    title: "Air Conditioning Not Working",
    description: "AC unit stopped working yesterday. It's getting very hot in the apartment.",
    priority: "high",
    status: "pending",
    category: "hvac",
    submittedDate: "2024-07-30",
    scheduledDate: null,
    images: []
  },
  {
    id: 3,
    tenantId: 4,
    tenantName: "Emily Davis",
    propertyName: "City Center Tower",
    unitNumber: "D408",
    title: "Bathroom Light Fixture",
    description: "Bathroom light fixture is flickering and needs to be replaced.",
    priority: "low",
    status: "completed",
    category: "electrical",
    submittedDate: "2024-07-25",
    scheduledDate: "2024-07-27",
    completedDate: "2024-07-27",
    images: []
  }
];

export const mockUser = {
  id: 1,
  name: "David Wilson",
  email: "david.wilson@landlord.com",
  role: "landlord",
  company: "Wilson Property Management",
  phone: "+1 (555) 123-0000",
  profileImage: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=150&h=150&fit=crop&crop=face"
};

export const mockTenantUser = {
  id: 1,
  name: "John Smith",
  email: "john.smith@email.com",
  role: "tenant",
  phone: "+1 (555) 123-4567",
  propertyId: 1,
  unitNumber: "A101",
  rentAmount: 850,
  profileImage: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face"
};

export const mockDocuments = [
  {
    id: 1,
    name: "Lease Agreement - A101",
    type: "lease",
    tenantId: 1,
    size: "245 KB",
    uploadDate: "2024-01-01",
    url: "#"
  },
  {
    id: 2,
    name: "Insurance Certificate - A101",
    type: "insurance",
    tenantId: 1,
    size: "156 KB",
    uploadDate: "2024-01-15",
    url: "#"
  },
  {
    id: 3,
    name: "Property Inspection - July 2024",
    type: "inspection",
    propertyId: 1,
    size: "892 KB",
    uploadDate: "2024-07-15",
    url: "#"
  }
];

export const mockContractors = [
  {
    id: 1,
    name: "ABC Plumbing Services",
    contactPerson: "Mike Johnson",
    phone: "+1 (555) 101-2030",
    email: "mike@abcplumbing.com",
    specialties: ["plumbing", "emergency_repair"],
    rating: 4.8,
    hourlyRate: 85,
    availability: "available",
    lastWorked: "2024-07-15",
    completedJobs: 23,
    profileImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face"
  },
  {
    id: 2,
    name: "Elite HVAC Solutions",
    contactPerson: "Sarah Chen",
    phone: "+1 (555) 202-4050",
    email: "sarah@elitehvac.com",
    specialties: ["hvac", "air_conditioning", "heating"],
    rating: 4.9,
    hourlyRate: 95,
    availability: "busy",
    lastWorked: "2024-07-28",
    completedJobs: 45,
    profileImage: "https://images.unsplash.com/photo-1494790108755-2616b612b5fc?w=150&h=150&fit=crop&crop=face"
  },
  {
    id: 3,
    name: "Bright Electrical Works",
    contactPerson: "David Rodriguez",
    phone: "+1 (555) 303-6070",
    email: "david@brightelectrical.com",
    specialties: ["electrical", "lighting", "wiring"],
    rating: 4.7,
    hourlyRate: 75,
    availability: "available",
    lastWorked: "2024-07-20",
    completedJobs: 31,
    profileImage: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face"
  },
  {
    id: 4,
    name: "General Handyman Plus",
    contactPerson: "Emma Thompson",
    phone: "+1 (555) 404-8090",
    email: "emma@handymanplus.com",
    specialties: ["general_maintenance", "painting", "carpentry"],
    rating: 4.6,
    hourlyRate: 60,
    availability: "available",
    lastWorked: "2024-07-25",
    completedJobs: 67,
    profileImage: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face"
  }
];

export const mockWorkOrders = [
  {
    id: 1,
    maintenanceRequestId: 1,
    contractorId: 1,
    contractorName: "ABC Plumbing Services",
    title: "Kitchen Faucet Leak Repair",
    description: "Replace faulty kitchen faucet and check for additional leaks",
    estimatedCost: 150,
    actualCost: 145,
    scheduledDate: "2024-08-02",
    completedDate: null,
    status: "assigned",
    priority: "medium",
    materials: ["Kitchen faucet", "Plumber's tape", "Pipe fittings"],
    laborHours: 2,
    notes: "Customer will be home between 9 AM - 12 PM"
  },
  {
    id: 2,
    maintenanceRequestId: 2,
    contractorId: 2,
    contractorName: "Elite HVAC Solutions",
    title: "AC Unit Repair",
    description: "Diagnose and repair non-functioning air conditioning unit",
    estimatedCost: 300,
    actualCost: null,
    scheduledDate: "2024-08-05",
    completedDate: null,
    status: "pending",
    priority: "high",
    materials: ["AC filters", "Refrigerant", "Electrical components"],
    laborHours: 4,
    notes: "Emergency repair - tenant experiencing extreme heat"
  }
];